import { render } from "./BaseFnbFooter.vue?vue&type=template&id=21c126e2&scoped=true"
import script from "./BaseFnbFooter.vue?vue&type=script&lang=js"
export * from "./BaseFnbFooter.vue?vue&type=script&lang=js"

import "./BaseFnbFooter.vue?vue&type=style&index=0&id=21c126e2&scoped=true&lang=scss"

import exportComponent from "/opt/render/project/src/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21c126e2"]])

export default __exports__